/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Minimum_WarningInputs */

const en_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must select at least two event groups to merge`)
};

const fr_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez selectionner au moins deux groupes d'evenements a fusionner`)
};

const de_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie müssen mindestens zwei Ereignisgruppen auswählen, die zusammengeführt werden sollen.`)
};

const it_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi selezionare almeno due gruppi di eventi da unire`)
};

const ru_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для объединения необходимо выбрать как минимум две группы событий.`)
};

const es_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes seleccionar al menos dos grupos de eventos para fusionar`)
};

const zh_cn2_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您必须选择至少两个事件组进行合并。`)
};

const ja_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージするには少なくとも 2 つのイベント グループを選択する必要があります`)
};

const hi_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको विलय करने के लिए कम से कम दो इवेंट समूहों का चयन करना होगा।`)
};

const pt_pt2_merge_event_group_minimum_warning = /** @type {(inputs: Merge_Event_Group_Minimum_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você deve selecionar pelo menos dois grupos de eventos para mesclar.`)
};

/**
* | output |
* | --- |
* | "You must select at least two event groups to merge" |
*
* @param {Merge_Event_Group_Minimum_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_minimum_warning = /** @type {((inputs?: Merge_Event_Group_Minimum_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Minimum_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_minimum_warning(inputs)
	if (locale === "de") return de_merge_event_group_minimum_warning(inputs)
	if (locale === "it") return it_merge_event_group_minimum_warning(inputs)
	if (locale === "ru") return ru_merge_event_group_minimum_warning(inputs)
	if (locale === "es") return es_merge_event_group_minimum_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_minimum_warning(inputs)
	if (locale === "ja") return ja_merge_event_group_minimum_warning(inputs)
	if (locale === "hi") return hi_merge_event_group_minimum_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_minimum_warning(inputs)
	return en_merge_event_group_minimum_warning(inputs)
});